export function hasAccountIdentifier(accountNumber?: string, iban?: string): boolean {
  return Boolean(accountNumber?.trim() || iban?.trim());
}

export function validateBankingIdentifiers(
  accountNumber?: string,
  iban?: string,
): string | null {
  if (!hasAccountIdentifier(accountNumber, iban)) {
    return 'Account Number or IBAN is required';
  }
  return null;
}
